
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import url from "../api/url";
import calcularEdad from "../functions/calcularEdad";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";

export const useRegistro = () => {

    const { URL } = url()

    const objLogueado = useEmpleadoStore(state => state.objLogueado)

    if (objLogueado.permitido !== "empleado") {
        window.location = "/"
    }

    // alertas
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mostrarAlertaUltimaSize, setMostrarAlertaUltimaSize] = useState(false);
    const [mostrarAlertaNoPdf, setMostrarAlertaNoPdf] = useState(false);
    const [mostrarAlertaSize, setMostrarAlertaSize] = useState(false);
    const [mostrarAlertaSizeColor, setMostrarAlertaSizeColor] = useState("");
    const [mostrarAlertaSizeTexto, setMostrarAlertaSizeTexto] = useState(false);
    const [cargando, setCargando] = useState(false)

    const [nombre, setNombre] = useState( () => {
        return (objLogueado.nombre) ? objLogueado.nombre : ""
    })
    const [apellidos, setApellidos] = useState( () => {
        return (objLogueado.apellido) ? objLogueado.apellido : ""
    })
    const [fecha_ingreso, setFecha_ingreso] = useState("")
    const [rfc, setRfc] = useState("")
    const [nss, setNss] = useState("")
    const [curp, setCurp] = useState("")
    const [fnac, setFnac] = useState("")
    const [edad, setEdad] = useState("")
    const [nacionalidad, setNacionalidad] = useState("")
    const [estado_civil, setEstado_civil] = useState("0")
    const [sexo, setSexo] = useState("0")
    const [tel, setTel] = useState("")
    const [celular, setCelular] = useState("")
    const [email, setEmail] = useState( () => {
        return (objLogueado.email) ? objLogueado.email : ""
    })
    const [emailPersonal, setEmailPersonal] = useState("")
    const [exp_docente, setExp_docente] = useState("")
    const [exp_sector, setExp_sector] = useState("")

    const [pk_empleado, setPk_empleado] = useState()

    const [archivo, setArchivo] = useState(null);

    const testear = () => {

        let formData = new FormData();
        formData.append('funcion', 'testear');

        fetch( URL , {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {


            if (d[0] === 0) {


            } else {
                Swal.fire(
                    'Hay un problema al conectar con el servidor.',
                    '',
                    'error'
                )
            }
        })
        .catch((error) => {
            setCargando(false)
            Swal.fire(
                'Hay un problema al conectar con el servidor.',
                '',
                'error'
            )
        });
    }


    const procesarArchivos = (e) => {

        if (e.target.value !== "") {

            var archivo = e.target.files[0]
            var size = archivo.size

            if (size > 52428800) {
                setMostrarAlertaSize(true)
                setMostrarAlertaSizeTexto("Archivo demasiado grande")
                setMostrarAlertaSizeColor("warning")
                setMostrarAlertaUltimaSize(true)
            } else {
                setMostrarAlertaSize(false)
                setMostrarAlertaSizeTexto("Archivo válido")
                setMostrarAlertaSizeColor("success")
                setMostrarAlertaUltimaSize(false)
            }

            var tipo = archivo.name.substr(-4)

            if (tipo === ".pdf") {

                setMostrarAlertaNoPdf(false)

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => {
                    setArchivo(f.target.result)
                }
            } else {
                setMostrarAlertaNoPdf(true)
            }
        } else {
            setMostrarAlertaSize(true)
        }
    }


    const submit = (e) => {
        setMostrarAlertaUltimaSize(false)
        e.preventDefault()

        // si existe un empleado no debe actualizar el cv y allí termina la función
        if ( pk_empleado ) {
            mandarDatos( false )
            return
        }

        // si el empleado es nuevo debe subir su cv
        if ( existen_vacios() || mostrarAlertaSize ) {

            if (mostrarAlertaSize) {
                setMostrarAlertaUltimaSize(true)
            } else {
                setMostrarAlerta(true)
            }

        } else {
            mandarDatos( true )
        }

    }


    const mandarDatos = ( mandarCv ) => {
        setMostrarAlerta(false)
        setCargando(true)

        let formData = new FormData();
        formData.append('funcion', 'guardar_empleado');
        // formData.append('funcion', 'hola');

        if ( mandarCv ) {
            formData.append('archivo', archivo);
            formData.append('mandarCv', "si");
        } else {
            formData.append('mandarCv', "no");
        }

        formData.append('nombre', nombre);
        formData.append('apellidos', apellidos);
        formData.append('fecha_ingreso', fecha_ingreso);
        formData.append('rfc', rfc);
        formData.append('nss', nss);
        formData.append('curp', curp);
        formData.append('fnac', fnac);
        formData.append('edad', edad);
        formData.append('nacionalidad', nacionalidad);
        formData.append('estado_civil', estado_civil);
        formData.append('sexo', sexo);
        formData.append('tel', tel);
        formData.append('cel', celular);
        formData.append('email', email);

        if(emailPersonal?.length === 0){
            formData.append('emailPersonal', "");
        }else{
            formData.append('emailPersonal', emailPersonal);

        }
        formData.append('exp_docente', exp_docente);
        formData.append('exp_sector', exp_sector);
        formData.append('pk_empleado', pk_empleado)


        fetch( URL , {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {

            setCargando(false)

            if (d.codigo === 1) {
                Swal.fire(
                    'Datos registrados con éxito!',
                    '',
                    'success'
                )
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
                // limpiarCampos()
            } else {
                Swal.fire(
                    d.mensaje,
                    '',
                    'warning'
                )
            }

        })
        .catch((error) => {
            setCargando(false)
            Swal.fire(
                'Hubo un error al registrar los datos!',
                '',
                'error'
            )
        });
    }


    const llenarDatos = () => {

        setNombre("Jesús Manuel")
        setApellidos("Salcido Aguilar")
        setFecha_ingreso("2021-02-01")
        setRfc("1010101010101")
        setNss("01010101010")
        setCurp("SAAJ98123456789")
        setFnac("1998-11-19")
        setEdad("23")
        setNacionalidad("Mexicana")
        setEstado_civil("Soltera(o)")
        setSexo("Masculino")
        setTel("6949513757")
        setCelular("6949513757")
        setEmail("jsalcido@utescuinapa.edu.mx")
        setEmailPersonal("")
        setExp_docente("Ninguna")
        setExp_sector("1 año en Grupo EXO")

    }


    const limpiarCampos = () => {

        setNombre("")
        setApellidos("")
        setFecha_ingreso("")
        setRfc("")
        setNss("")
        setCurp("")
        setFnac("")
        setEdad("")
        setNacionalidad("")
        setEstado_civil("")
        setSexo("")
        setTel("")
        setCelular("")
        setEmail("")
        setEmailPersonal("")
        setExp_docente("")
        setExp_sector("")
        document.getElementById("formFileLg").value = "";

    }


    const existen_vacios = () => {

        let arreglo_validados = []

        let v_nombre =          (nombre === "")                 ? true : false
        let v_apellidos =       (apellidos === "")              ? true : false
        let v_fecha_ingreso =   (fecha_ingreso === "")          ? true : false
        let v_rfc =             (rfc === "")                    ? true : false
        let v_nss =             (nss === "")                    ? true : false
        let v_curp =            (curp === "")                   ? true : false
        let v_fnac =            (fnac === "")                   ? true : false
        let v_edad =            (edad === "")                   ? true : false
        let v_nacionalidad =    (nacionalidad === "")           ? true : false
        let v_estado_civil =    (estado_civil === "0")          ? true : false
        let v_sexo =            (sexo === "0")                  ? true : false
        let v_tel =             (tel === "")                    ? true : false
        let v_celular =         (celular === "")                ? true : false
        let v_email =           (email === "")                  ? true : false
        let v_exp_docente =     (exp_docente === "")            ? true : false
        let v_exp_sector =      (exp_sector === "")             ? true : false

        arreglo_validados.push(v_nombre)
        arreglo_validados.push(v_apellidos)
        arreglo_validados.push(v_fecha_ingreso)
        arreglo_validados.push(v_rfc)
        arreglo_validados.push(v_nss)
        arreglo_validados.push(v_curp)
        arreglo_validados.push(v_fnac)
        arreglo_validados.push(v_edad)
        arreglo_validados.push(v_nacionalidad)
        arreglo_validados.push(v_estado_civil)
        arreglo_validados.push(v_sexo)
        arreglo_validados.push(v_tel)
        arreglo_validados.push(v_celular)
        arreglo_validados.push(v_email)
        arreglo_validados.push(v_exp_docente)
        arreglo_validados.push(v_exp_sector)

        return arreglo_validados.includes(true) ? true : false

    }

    // esta se ejecuta en cuanto carga la página
    const llenarInputs = () => {

        let body = new FormData()
        body.append("funcion", "traerDatosEmpleadoPorCorreo")
        body.append("email", objLogueado.email)

        fetch(URL, {
            method: "POST",
            body
        })
        .then(res => res.json())
        .then(function(datos){
            if (datos.length > 0) {

                let d = datos[0]

                setNombre( d.nombre )
                setApellidos( d.apellido )

                var f
                if ( d.fecha_ingreso ) {
                    f = d.fecha_ingreso.split(" ")[0]
                } else {
                    f = ""
                }

                setFecha_ingreso( f )
                setRfc( ( d.rfc ) ? d.rfc : "" )
                setNss( ( d.nss ) ? d.nss : "" )
                setCurp( ( d.curp ) ? d.curp : "" )
                setFnac( ( d.fnac ) ? d.fnac : "" )
                setNacionalidad( ( d.nacionalidad ) ? d.nacionalidad : "" )
                setEstado_civil( ( d.estado_civil ) ? d.estado_civil : "" )
                setSexo( ( d.sexo ) ? d.sexo : "" )
                setTel( ( d.tel ) ? d.tel : "" )
                setCelular( ( d.cel ) ? d.cel : "" )
                setEmailPersonal( ( d.email_personal ) ? d.email_personal : "" )
                setExp_docente( ( d.ext_docente ) ? d.ext_docente : "" )
                setExp_sector( ( d.exp_sector ) ? d.exp_sector : "" )
                setPk_empleado( ( d.pk_empleado ) ? d.pk_empleado : "" )
            }
        })
    }


    const actualizarLocal = () => {

        var datos_empleados = {
            nombre,
            apellidos,
            fecha_ingreso,
            rfc,
            nss,
            curp,
            fnac,
            edad,
            nacionalidad,
            estado_civil,
            sexo,
            tel,
            celular,
            email,
            emailPersonal,
            exp_docente,
            exp_sector,
        }
        window.localStorage.setItem("datos_empleados", JSON.stringify(datos_empleados))

    }


    const actualizarArchivoCv = (e) => {
        e.preventDefault()

        if (mostrarAlertaSize) {
            alert("Archivo demasiado grande")
            return;
        }

        setMostrarAlerta(false)
        setCargando(true)

        let formData = new FormData();
        formData.append('funcion', 'actualizarArchivoCv');
        formData.append('archivo', archivo);
        formData.append('email', email);

        fetch( URL , {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(function (d) {
            setCargando(false)

            if (d.codigo === 1) {
                Swal.fire(
                    'Datos registrados con éxito!',
                    '',
                    'success'
                )
                limpiarCampos()
            } else {
                Swal.fire(
                    d.mensaje,
                    '',
                    'warning'
                )
            }

        })
        .catch((error) => {
            setCargando(false)
            Swal.fire(
                'Hubo un error al registrar los datos!',
                '',
                'error'
            )
        });

    }



    // efectos

    useEffect(() => {
        testear()

        llenarInputs()
        // eslint-disable-next-line
    }, [])


    useEffect(() => {

        if (fnac?.length > 0) {
            var edadCalculada = calcularEdad(fnac)
            setEdad(edadCalculada)
        }

    }, [fnac])


    useEffect(() => {
        actualizarLocal()
        // eslint-disable-next-line
    }, [nombre, apellidos, fecha_ingreso, rfc, nss, curp, fnac, edad, nacionalidad, estado_civil, sexo, tel, celular, email, emailPersonal, exp_docente, exp_sector])


    const btn = cargando ? (
        <>
            <button
                type='submit'
                className="btn btn-primary btn-block"
                disabled
            >
                <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                &nbsp; Guardando
            </button>
        </>
    ) : (
        <>
            <button
                type='submit'
                className="btn btn-primary btn-block"
            >
                Guardar datos
            </button>
        </>
    )

    return {
        mostrarAlerta,
        nombre,
        setNombre,
        apellidos,
        setApellidos,
        fecha_ingreso,
        setFecha_ingreso,
        rfc,
        setRfc,
        nss,
        setNss,
        curp,
        setCurp,
        fnac,
        setFnac,
        edad,
        setEdad,
        nacionalidad,
        setNacionalidad,
        estado_civil,
        setEstado_civil,
        sexo,
        setSexo,
        tel,
        setTel,
        celular,
        setCelular,
        email,
        setEmail,
        emailPersonal,
        setEmailPersonal,
        exp_docente,
        setExp_docente,
        exp_sector,
        setExp_sector,
        archivo,
        procesarArchivos,
        submit,
        llenarDatos,
        mostrarAlertaNoPdf,
        btn,
        mostrarAlertaSize,
        mostrarAlertaSizeTexto,
        mostrarAlertaSizeColor,
        mostrarAlertaUltimaSize,
        actualizarArchivoCv,
        pk_empleado
    }

}
